// @ts-nocheck
/**
Channel
=======

A channel holds a sequence of patterns. The patterns are stored in the `data`
table at beat keys with `patternId` values.

Status: Legacy
*/

Model from ../model.civet

export Channel := (I={}, self=new Model(I)) ->
  defaults I,
    data: {}

  patternStarts := (patterns) ->
    Object.keys(I.data).map (_start) ->
      start := parseInt(_start, 10)
      patternIndex := parseInt(I.data[start], 10)
      pattern := patterns[patternIndex]
      end := start + pattern.size()

      [start, end, pattern, patternIndex] as const

  self.extend
    patterns: patternStarts

    canSet: (beat: number, patternIndex, patterns) ->
      size := patterns[patternIndex].size()

      toInsert := [beat, beat + size] as const

      // Can't set if there are any overlaps
      !patternStarts(patterns).some (segment) ->
        overlap(toInsert, segment)

    patternDataAt: (beat: number, patterns) ->
      patternStarts(patterns).filter ([start, end]) ->
        start <= beat < end

    patternAt: (beat: number, patterns) ->
      self.patternDataAt(beat, patterns)
      .map(([start, end, pattern, patternIndex]) ->
        patternIndex
      )[0]

    setPattern: (beat: number, patternIndex) ->
      I.data[beat] = patternIndex

    removePattern: (beat: number, patterns) ->
      patternsAtBeat := patternStarts(patterns).filter ([start, end]) ->
        start <= beat < end

      patternsAtBeat.forEach ([start]) ->
        delete I.data[start]

      return patternsAtBeat.length > 0

    upcomingNotes: (t: number, dt: number, patterns) ->
      patternStarts(patterns).filter ([start, end, pattern]) ->
        (or)
          (start <= t < end)    // t is within pattern or
          (t <= start < t + dt) // pattern start is within [t, t + dt)
      .map ([start, end, pattern]) ->
        offset := t - start

        pattern.upcomingNotes(offset, dt)
      .flat()

    size: (patterns) ->
      patternStarts(patterns).reduce (n, [start, end]) ->
        max n, end
      , 0

  return self


{min, max} := Math

overlap := ([a1, a2]: readonly [number, number], [b1, b2]: readonly [number, number]) ->
  max(0, min(a2, b2) - max(a1, b1)) > 0

export default Channel
